import React, { Component } from 'react';
import { observer, inject } from 'mobx-react'; 
import { withStyles } from '@material-ui/core/styles';
//import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import DriverIcon from '@material-ui/icons/PermContactCalendar';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Upload from './Upload';
import CloseIcon from '@material-ui/icons/ExitToApp';
import SaveIcon from '@material-ui/icons/Save';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


const styles = theme => ({
    paper: {
        flexGrow: 1, 
        padding: theme.spacing(2),
        display: 'flex',
        flexFlow: 'column',
      },
      icon: {
        fontSize: 100,
        color: '#607d8b',
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
      },
      leftCol:{
        textAlign: 'center',
      },
      rightCol: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexFlow: 'column',
        padding: theme.spacing(2)
      },
      input: {
          flexGrow: 1,
          marginTop: theme.spacing(2)
      },
      buttons: {
        marginTop: theme.spacing(8),
        flexGrow: 1,
        display: 'flex',
        flexFlow: 'row',
        justifyContent: 'space-between',
      }
});

class DriversDetails extends Component {
    state = {
        driver: {},
        askDeldlgOpen: false,
    }

    handleSwitchAvailable = event => {
        let status = 'Active';
        if(event.target.checked===false){
            status = 'Inactive';
        } 
        this.props.appState.driver.STATUS = status;
    }

    communicate = (qry, route) =>{
        this.props.appState.appRoutine.loading = true;

        fetch(this.props.appState.appRoutine.apiUrl + route, 
          {
          method: 'POST', // or 'PUT'
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(qry),
          })
          .then(res => res.json())
          .then(
            (result) => {
                this.props.appState.appRoutine.loading = false;
              if(result.status === 'err'){
                alert(result)
              };
              if(result.result.insertId>0){
                this.props.appState.driver.ID = result.result.insertId;
              }
              this.props.appState.appRoutine.msg = {
                text: 'Saved',
                open: true,
                type: 'success',
              }
              this.props.reload();
            },
            (error) => {
                this.props.appState.appRoutine.loading = false;
                alert(error)
            }
          )
    }

    handleUpdate = () => {
         const qry = this.props.appState.driver;
         let route =  'drivers/update';
         if(this.props.appState.driver.ID === 0){
            route =  'drivers/insert'
         }
         this.communicate(qry, route);
      }

    handleClose = () => {
        this.props.appState.driver = {};
     }

      

    doDelete = () => {
        const qry = {
            'id': this.props.appState.driver.ID,
            'file': this.props.appState.driver.PHOTO,

        }
        const route = 'drivers/delete';
        this.communicate(qry, route);
        this.props.appState.driver = {};
    }

  render() {
    const {classes, appState} = this.props;
    

    return (
            <div>
                <Paper className={classes.paper}>
                    <Grid container className={classes.root} spacing={3}>
                        <Grid item xs={12} sm={12} md={4} className={classes.leftCol} >
                                {this.props.appState.driver.PHOTO===''?
                                <DriverIcon className={classes.icon}/>
                                :
                                <img 
                                    src={window.location.origin + '/files/photos/' + this.props.appState.driver.PHOTO}
                                    alt={this.props.appState.driver.SURNAME}
                                    style={{
                                        marginTop: 30,
                                        width: "80%",
                                        borderRadius: 5,
                                    }}
                                    
                                    />
                                }
                                <Upload 
                                    type="photo"
                                    title="photo"
                                    id={this.props.appState.driver.ID}
                                    style={{marginTop: 20}}
                                    reload={this.props.reload}
                                    />
                        </Grid>
                        <Grid item xs={12} sm={12} md={8} className={classes.rightCol}>
                        <Grid container spacing={3}>
                                <Grid item xs={12} sm={12} md={6}  style={{display: 'flex'}}>
                                    <TextField 
                                        label="Name" 
                                        variant="outlined" 
                                        className={classes.input} 
                                        value={appState.driver.NAME}
                                        onChange={(event)=>{appState.driver.NAME = event.target.value}}
                                        />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} style={{display: 'flex'}}>
                                    <TextField 
                                        label="Surname" 
                                        variant="outlined" 
                                        className={classes.input} 
                                        value={appState.driver.SURNAME}
                                        onChange={(event)=>{appState.driver.SURNAME = event.target.value}}
                                        />
                                </Grid> 
                            </Grid>   
                            <TextField label="Phone" 
                                variant="outlined" 
                                className={classes.input} 
                                value={appState.driver.PHONE}
                                onChange={(event)=>{appState.driver.PHONE = event.target.value}}
                                />
                            <TextField label="E-mail" 
                                variant="outlined" 
                                className={classes.input} 
                                value={appState.driver.EMAIL}
                                onChange={(event)=>{appState.driver.EMAIL = event.target.value}}
                                />
                            <TextField 
                                label="Address" 
                                variant="outlined" 
                                multiline rows='3' 
                                className={classes.input} 
                                value={appState.driver.ADDRESS}
                                onChange={(event)=>{appState.driver.ADDRESS = event.target.value}}
                                />                              
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={12} md={6}  style={{display: 'flex'}}>
                                    <TextField 
                                        label="Dr. Licence" 
                                        variant="outlined" 
                                        className={classes.input} 
                                        value={appState.driver.LICENCE}
                                        onChange={(event)=>{appState.driver.LICENCE = event.target.value}}
                                        />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} style={{display: 'flex'}}>
                                    <TextField 
                                        label="PCO" 
                                        variant="outlined" 
                                        className={classes.input} 
                                        value={appState.driver.PHV}
                                        onChange={(event)=>{appState.driver.PHV = event.target.value}}
                                        />
                                </Grid> 
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={12} md={6}  style={{display: 'flex'}}>
                                    <TextField 
                                        label="Vehicle" 
                                        variant="outlined" 
                                        className={classes.input} 
                                        value={appState.driver.VEHICLE}
                                        onChange={(event)=>{appState.driver.VEHICLE = event.target.value}}
                                        />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} >
                                    <FormControlLabel
                                        style={{padding: 8, marginLeft: 5}}
                                        className={classes.input}
                                        control={
                                        <Switch
                                            checked={appState.driver.STATUS==='Active'? true : false}
                                            onChange={this.handleSwitchAvailable}
                                            value={appState.driver.STATUS}
                                            color="primary"
                                        />
                                        }
                                        label="Active"
                                    />
                                </Grid>
                            </Grid>
                            <TextField 
                                label="Notes" 
                                variant="outlined" 
                                multiline rows='3' 
                                className={classes.input}
                                value={appState.driver.NOTES}
                                onChange={(event)=>{appState.driver.NOTES = event.target.value}}
                                />  
                            <div className={classes.buttons}>
                                <div>
                                <IconButton color="primary" aria-label="Delete" style={{margin: 10}} component="span" onClick={()=>this.setState({askDeldlgOpen: true})}>
                                  <DeleteIcon />
                                </IconButton>
                                </div>
                                <div>
                                <Button variant="contained" style={{margin: 10}} onClick={this.handleClose}>
                                    <CloseIcon />
                                </Button>    
                                <Button variant="contained" color="primary" style={{margin: 10}} onClick={this.handleUpdate}>
                                    <SaveIcon />
                                </Button>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Paper>


                <Dialog
                    open={this.state.askDeldlgOpen}
                    onClose={()=>this.setState({askDeldlgOpen: false})}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Delete?"}</DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Please confirm you really want to delete.
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={()=>this.setState({askDeldlgOpen: false})} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={this.doDelete} color="primary" autoFocus>
                        Confirm
                    </Button>
                    </DialogActions>
                </Dialog>
            </div>
    );
  }
}



export default withStyles(styles)(inject('appState')(observer(DriversDetails)));